import { DateSpan } from '../../../hooks/useSchedulingPreferences/types';
import { DATE_FORMAT } from '../helpers';
import { SchedulingPreferencesFormValues } from './types';
import { getTotalMinutesOfZonedDay } from '../dateUtils';
import { formatInTimeZone } from 'date-fns-tz';

/**
 * Converts scheduling hours DB data, which is in UTC, to the timezone and data type of the form
 */
export const parseAvailability = (
    availability: DateSpan[],
    timezoneId: string
): SchedulingPreferencesFormValues['availability'] => {
    const sortedDateIntervals = availability?.sort(
        (intervalA, intervalB) => intervalA.start.getTime() - intervalB.start.getTime()
    );
    // group by date for form
    return sortedDateIntervals?.reduce<SchedulingPreferencesFormValues['availability']>(
        (intervalSets, { start, end }) => {
            const startTimeMinutes = getTotalMinutesOfZonedDay(start, timezoneId);
            // for midnight date boundaries, round `end` from 1439 to 1440
            const endTimeMinutes = 5 * Math.round(getTotalMinutesOfZonedDay(end, timezoneId) / 5);
            const dateFormatted = formatInTimeZone(start, timezoneId, DATE_FORMAT);
            let existingSet = intervalSets.find(set => dateFormatted === set.date);
            if (!existingSet) {
                existingSet = { date: dateFormatted, intervals: [] };
                intervalSets.push(existingSet);
            }
            existingSet.intervals.push({ start: startTimeMinutes, end: endTimeMinutes });
            return intervalSets;
        },
        []
    );
};

export default parseAvailability;
